import { useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle, Send } from "lucide-react";
import { waLink, IMAGES } from "../data/content";

export const Contact = () => {
  const [form, setForm] = useState({ nama: "", tipe: "Mansion", budget: "", pesan: "" });

  const submit = (e) => {
    e.preventDefault();
    const msg = `Halo PT Raditya Konstruksi,\n\nNama: ${form.nama}\nTipe Proyek: ${form.tipe}\nEstimasi Budget: ${form.budget}\nPesan: ${form.pesan}\n\nSaya ingin menjadwalkan konsultasi.`;
    window.open(waLink(msg), "_blank", "noopener,noreferrer");
  };

  const field =
    "w-full bg-obsidian/60 border border-white/10 focus:border-brass/60 text-bone text-sm font-light px-4 py-3.5 outline-none transition-colors duration-300 placeholder:text-dim";

  return (
    <section id="kontak" data-testid="contact-section" className="relative py-28 lg:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.interior2} alt="" className="w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian via-obsidian/85 to-obsidian" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono-arch text-[11px] tracking-[0.35em] uppercase text-brass mb-5">Konsultasi Gratis</p>
          <h2 className="font-serif-lux font-light text-3xl sm:text-4xl lg:text-5xl text-bone tracking-tight leading-[1.12]">
            Mahakarya Anda dimulai dari <span className="italic brass-text-gradient">satu percakapan.</span>
          </h2>
          <p className="text-sm sm:text-base text-ash font-light leading-relaxed mt-6 max-w-md">
            Ceritakan lahan, visi, dan budget Anda. Tim kami merespons di jam kerja
            (Senin–Sabtu, 08.00–18.00 WIB) dengan analisis awal dan estimasi kasar.
          </p>
          <a
            data-testid="contact-wa-direct-btn"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 inline-flex items-center gap-3 bg-wa hover:bg-wahover text-obsidian font-mono-arch text-xs tracking-[0.18em] uppercase px-7 py-4 transition-colors duration-300"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={2.2} />
            Chat Langsung Sekarang
          </a>
          <div className="mt-12 space-y-3 font-mono-arch text-xs text-dim tracking-[0.15em]">
            <p data-testid="contact-address">JAKARTA • BALI • SURABAYA</p>
            <p data-testid="contact-email">HALO@RADITYAKONSTRUKSI.CO.ID</p>
          </div>
        </motion.div>

        <motion.form
          data-testid="contact-form"
          onSubmit={submit}
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          className="bg-surface/80 backdrop-blur-md border border-white/10 p-8 lg:p-10 space-y-5"
        >
          <p className="font-mono-arch text-[10px] tracking-[0.3em] uppercase text-brass">
            Formulir Penawaran — Terkirim ke WhatsApp
          </p>
          <div>
            <label htmlFor="cf-nama" className="block font-mono-arch text-[10px] tracking-[0.25em] uppercase text-dim mb-2">Nama Lengkap</label>
            <input
              id="cf-nama"
              data-testid="contact-form-name-input"
              required
              value={form.nama}
              onChange={(e) => setForm({ ...form, nama: e.target.value })}
              placeholder="Nama Anda"
              className={field}
            />
          </div>
          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <label htmlFor="cf-tipe" className="block font-mono-arch text-[10px] tracking-[0.25em] uppercase text-dim mb-2">Tipe Proyek</label>
              <select
                id="cf-tipe"
                data-testid="contact-form-type-select"
                value={form.tipe}
                onChange={(e) => setForm({ ...form, tipe: e.target.value })}
                className={field}
              >
                <option>Mansion</option>
                <option>Villa Tropis</option>
                <option>Modern Minimal</option>
                <option>Renovasi</option>
                <option>Interior / Joinery</option>
              </select>
            </div>
            <div>
              <label htmlFor="cf-budget" className="block font-mono-arch text-[10px] tracking-[0.25em] uppercase text-dim mb-2">Estimasi Budget</label>
              <input
                id="cf-budget"
                data-testid="contact-form-budget-input"
                value={form.budget}
                onChange={(e) => setForm({ ...form, budget: e.target.value })}
                placeholder="cth. Rp 5–10 Miliar"
                className={field}
              />
            </div>
          </div>
          <div>
            <label htmlFor="cf-pesan" className="block font-mono-arch text-[10px] tracking-[0.25em] uppercase text-dim mb-2">Pesan</label>
            <textarea
              id="cf-pesan"
              data-testid="contact-form-message-input"
              rows={4}
              value={form.pesan}
              onChange={(e) => setForm({ ...form, pesan: e.target.value })}
              placeholder="Ceritakan lahan & visi Anda…"
              className={`${field} resize-none`}
            />
          </div>
          <button
            data-testid="contact-form-submit-btn"
            type="submit"
            className="group w-full inline-flex items-center justify-center gap-3 bg-brass hover:bg-gold text-obsidian font-mono-arch text-xs tracking-[0.2em] uppercase px-7 py-4 transition-colors duration-300"
          >
            Kirim via WhatsApp
            <Send className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
          </button>
        </motion.form>
      </div>
    </section>
  );
};
